import React from "react";

import ProcessingBadge from "@app/analytics/components/Badges/ProcessingBadge";
import { isMenuCloseEvent } from "@app/analytics/MeetingReports/ReportsTable/utils";
import type { OnOpenReportHandler } from "@app/analytics/MeetingReports/types";
import type { UserMeeting } from "@app/common/types";
import { formatStartAndEndTime } from "@app/common/utils";

import { Row } from "@rui/Stack";

import OwnerCell from "../cells/OwnerCell";
import SourceCell from "../cells/SourceCell";
import {
  ProcessingCell,
  ProcessingCellText,
  ProcessingTableRow,
} from "../styles";

const MeetingReportProcessingRow = ({
  report,
  onOpenReport,
}: {
  report: UserMeeting;
  onOpenReport: OnOpenReportHandler;
}) => {
  const handleClickRow = (
    e: React.MouseEvent<HTMLElement>,
    openNewTab = false
  ) => {
    if (isMenuCloseEvent(e)) return;

    const newTab =
      openNewTab || e.button == 1 || e.buttons == 4 || e.ctrlKey || e.metaKey;
    onOpenReport(report.id, { newTab, type: "session" });
  };

  return (
    <ProcessingTableRow
      data-sid={report.id}
      onClick={handleClickRow}
      onAuxClick={handleClickRow}
    >
      <ProcessingCell>
        <SourceCell report={report} asCell={false} />
      </ProcessingCell>
      <ProcessingCell sx={{ maxWidth: "300px" }}>
        <Row variant="left" spacing={2}>
          <ProcessingCellText>{report.title}</ProcessingCellText>
          <ProcessingBadge />
        </Row>
      </ProcessingCell>
      <ProcessingCell>
        <ProcessingCellText>
          {report.startTime.toLocaleString({
            weekday: "short",
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
        </ProcessingCellText>
        <ProcessingCellText variant="labelReg">
          {formatStartAndEndTime(report.startTime, report.endTime)}
        </ProcessingCellText>
      </ProcessingCell>
      <ProcessingCell colSpan={2}>
        <ProcessingCellText>
          Details will be available once processing is complete
        </ProcessingCellText>
      </ProcessingCell>
      <ProcessingCell>
        <OwnerCell owner={report.ownerName} asCell={false} />
      </ProcessingCell>
      <ProcessingCell>{/* Placeholder for actions column */}</ProcessingCell>
    </ProcessingTableRow>
  );
};

export default MeetingReportProcessingRow;
